/**
 * Created by jacky on 5/31/16.
 */
import "./social.scss";

import React from "react";
import { GA } from '../../lib/analytics';

type SocialData = {
    tweet: string;
    ogTitle: string;
    ogDescription: string;
    ogImage: string;
}
declare var socialData: SocialData;
declare var contentPool;
declare var contentId;

interface ISocialProps {
    projectName: string;
}

export default class Social extends React.Component<ISocialProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            fb: null,
            twiter: null,
            linkedId: null
        }
    }

    _onFBShare() {
        GA({category: 'Social', action: 'Facebook', value: `${contentPool}/${contentId}`});
        windowOpen('//facebook.com/sharer.php' + objectToGetParams({ u: window.location.href }));
    }

    _onTwitterShare() {
        GA({category: 'Social', action: 'Twitter', value: `${contentPool}/${contentId}`});
        windowOpen('//twitter.com/share' + objectToGetParams({
            url: window.location.href,
            text: socialData.tweet,
            via: 'http://casual.pm'
        }));
    }

    _onLinkedInShare() {
        GA({category: 'Social', action: 'LinkedIn', value: `${contentPool}/${contentId}`});
        windowOpen('//linkedin.com/shareArticle' + objectToGetParams({
                url: window.location.href,
                title: socialData.ogTitle,
                mini: true,
                summary: socialData.ogDescription
            })
        )
    }

    _onGooglePlus() {
        GA({category: 'Social', action: 'GooglePlus', value: `${contentPool}/${contentId}`});
        windowOpen('//plus.google.com/share' + objectToGetParams({ url: window.location.href }));
    }

    render() {
        return (
            <div className="clsSocialContainer">
                <div className="clsSocial-facebook" onClick={e => this._onFBShare()}>
                    <svg className="clsSocial-icon" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"/></svg>
                </div>
                <div className="clsSocial-twitter" onClick={e => this._onTwitterShare(e)}>
                    <svg className="clsSocial-icon" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M1684 408q-67 98-162 167 1 14 1 42 0 130-38 259.5t-115.5 248.5-184.5 210.5-258 146-323 54.5q-271 0-496-145 35 4 78 4 225 0 401-138-105-2-188-64.5t-114-159.5q33 5 61 5 43 0 85-11-112-23-185.5-111.5t-73.5-205.5v-4q68 38 146 41-66-44-105-115t-39-154q0-88 44-163 121 149 294.5 238.5t371.5 99.5q-8-38-8-74 0-134 94.5-228.5t228.5-94.5q140 0 236 102 109-21 205-78-37 115-142 178 93-10 186-50z"/></svg>
                </div>
                <div className="clsSocial-linkedin" onClick={e => this._onLinkedInShare()}>
                    <svg className="clsSocial-icon" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M477 625v991h-330v-991h330zm21-306q1 73-50.5 122t-135.5 49h-2q-82 0-132-49t-50-122q0-74 51.5-122.5t134.5-48.5 133 48.5 51 122.5zm1166 729v568h-329v-530q0-105-40.5-164.5t-126.5-59.5q-63 0-105.5 34.5t-63.5 85.5q-11 30-11 81v553h-329q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5 114.5-15.5q171 0 275 113.5t104 332.5z"/></svg>
                </div>
                <div className="clsSocial-google-plus" onClick={e => this._onGooglePlus()}>
                    <svg className="clsSocial-icon" viewBox="0 0 56.693 56.693" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path fill="currentColor" d="M52.218,25.852h-7.512v-7.51c0-0.573-0.465-1.039-1.037-1.039H41.53c-0.576,0-1.041,0.466-1.041,1.039v7.51h-7.512   c-0.572,0-1.039,0.467-1.039,1.041v2.139c0,0.574,0.467,1.039,1.039,1.039h7.512v7.514c0,0.574,0.465,1.039,1.041,1.039h2.139   c0.572,0,1.037-0.465,1.037-1.039V30.07h7.512c0.572,0,1.039-0.465,1.039-1.039v-2.139C53.257,26.318,52.79,25.852,52.218,25.852z"/>
                        <path fill="currentColor" d="M26.974,32.438c-1.58-1.119-3.016-2.76-3.041-3.264c0-0.918,0.082-1.357,2.141-2.961c2.662-2.084,4.128-4.824,4.128-7.719   c0-2.625-0.802-4.957-2.167-6.595h1.059c0.219,0,0.434-0.068,0.609-0.196l2.955-2.141c0.367-0.263,0.521-0.732,0.381-1.161   c-0.141-0.428-0.537-0.72-0.988-0.72H18.835c-1.446,0-2.915,0.255-4.357,0.751c-4.816,1.661-8.184,5.765-8.184,9.978   c0,5.969,4.624,10.493,10.805,10.635c-0.121,0.473-0.182,0.939-0.182,1.396c0,0.92,0.233,1.791,0.713,2.633c-0.056,0-0.11,0-0.17,0   c-5.892,0-11.21,2.891-13.229,7.193c-0.526,1.119-0.794,2.25-0.794,3.367c0,1.086,0.279,2.131,0.826,3.113   c1.269,2.27,3.994,4.031,7.677,4.961c1.901,0.48,3.944,0.725,6.065,0.725c1.906,0,3.723-0.246,5.403-0.732   c5.238-1.521,8.625-5.377,8.625-9.828C32.032,37.602,30.659,35.045,26.974,32.438z M10.283,42.215c0-3.107,3.947-5.832,8.446-5.832   h0.121c0.979,0.012,1.934,0.156,2.834,0.432c0.309,0.213,0.607,0.416,0.893,0.611c2.084,1.42,3.461,2.357,3.844,3.861   c0.09,0.379,0.135,0.758,0.135,1.125c0,3.869-2.885,5.83-8.578,5.83C13.663,48.242,10.283,45.596,10.283,42.215z M14.377,12.858   c0.703-0.803,1.624-1.227,2.658-1.227l0.117,0.002c2.921,0.086,5.716,3.341,6.23,7.256c0.289,2.192-0.199,4.253-1.301,5.509   c-0.705,0.805-1.613,1.229-2.689,1.229c0,0,0,0-0.002,0h-0.047c-2.861-0.088-5.716-3.467-6.227-7.377   C12.829,16.064,13.289,14.099,14.377,12.858z"/>
                    </g>
                    </svg>
                </div>
            </div>
        );
    }
}

export function windowOpen(url: string, name?: string, height: number = 400, width: number = 550) {
    const left = (window.outerWidth / 2)
        + (window.screenX || window.screenLeft || 0) - (width / 2);
    const top = (window.outerHeight / 2)
        + (window.screenY || window.screenTop || 0) - (height / 2);

    const config = {
        height,
        width,
        left,
        top,
        location: 'no',
        toolbar: 'no',
        status: 'no',
        directories: 'no',
        menubar: 'no',
        scrollbars: 'yes',
        resizable: 'no',
        centerscreen: 'yes',
        chrome: 'yes',
    };

    return window.open(
        url,
        name,
        Object.keys(config).map(key => `${key}=${config[key]}`).join(', ')
    );
}

export function objectToGetParams(object) {
    return '?' + Object.keys(object)
            .filter(key => !!object[key])
            .map(key => `${key}=${encodeURIComponent(object[key])}`)
            .join('&');
}



// WEBPACK FOOTER //
// ./src/components/Social/social.jsx